module.exports = __webpack_public_path__ + "img/forgot-password-v2-dark.33d1fea3.svg";